export { default } from "@casino/client/hooks/useNotificationText";
